<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-contextMenu #cm [model]="menuContextuelRequisitions"></p-contextMenu>

<p-card *ngIf="!EstCharge()">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 my-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-card>

<div class="grid" *ngIf="EstCharge()">
    <div class="col-12">

        <p-card>
            
            <p-tabView [scrollable]="true" [(activeIndex)]="activeIndex" styleClass="tabview-custom">
                <p-tabPanel header="Tous"></p-tabPanel>
                <p-tabPanel header="Réquisition" rightIcon="pi pi-arrow-right"></p-tabPanel>
                <p-tabPanel header="Retour" rightIcon="pi pi-arrow-left"></p-tabPanel>
                <p-tabPanel header="Transfert" rightIcon="pi pi-minus"></p-tabPanel>
            </p-tabView>

            <div class="my-4">
                <h5 class="my-1">Transports</h5>
                <span class="text-500">Les transports définissent les déplacements des items entre les emplacements.</span>
            </div>
            
            <div class="flex align-content-center justify-content-between mb-2">
                <div class="flex align-items-center gap-2">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input #recherche pInputText type="text" [(ngModel)]="globalFilter"
                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                            placeholder="Recherche..." autofocus />
                    </span>
                    <button *ngIf="estAutorise('requisition_creer')" pButton pRipple icon="pi pi-plus"
                                class="p-button-success" label="Ajouter"
                                (click)="AjouterRequisition()"></button>
                    <button pButton class="p-button-outlined" icon="pi pi-filter-slash" (click)="clearFilters(dt)" pTooltip="Réinitialiser les filtres"></button>
                </div>
                <div>
                    <app-selecteur-colonnes
                        [colonnesDisponibles]="colonnesDisponibles"
                        [(ngModel)]="selectedColumns"
                        (onChange)="surChangementColonnes($event)"
                        (onReset)="reinitialiserColonnesSelectionnees()">
                    </app-selecteur-colonnes>
                </div>
            </div>
            
            <p-table #dt [value]="filteredRequisitions()" [columns]="selectedColumns" dataKey="requisitionId" tableStyleClass="tableNormale"
                styleClass="p-datatable-sm p-datatable-striped" [(contextMenuSelection)]="selectionRequisition" sortMode="multiple" [multiSortMeta]="sortMeta"
                [contextMenu]="cm" [rowHover]="true" [rows]="100" [paginator]="true" [rowsPerPageOptions]="[10,25,50,100]"
                [globalFilterFields]="['numero','description']"
                (onFilter)="tableParams.setValue(dt)" 
                (onSort)="tableParams.setValue(dt)" 
                (onPage)="tableParams.setValue(dt)">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        
                        <th pSortableColumn="numero">
                            <div class="flex justify-content-between align-items-center">
                                Numéro
                                <p-sortIcon field="numero"></p-sortIcon>
                                <p-columnFilter type="numeric" field="numero" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="date">
                            <div class="flex justify-content-between align-items-center">
                                Date
                                <p-sortIcon field="date"></p-sortIcon>
                                <p-columnFilter type="date" field="date" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="statut.nom">
                            <div class="flex justify-content-between align-items-center">
                                Statut
                                <p-sortIcon field="statut.nom"></p-sortIcon>
                                <p-columnFilter type="text" field="statut.nom" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                       <!--  <th pSortableColumn="type">
                            <div class="flex justify-content-between align-items-center">
                                Type
                                <p-sortIcon field="type"></p-sortIcon>
                                <p-columnFilter type="text" field="type" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th> -->
                        <th pSortableColumn="de.nom">
                            <div class="flex justify-content-between align-items-center">
                                De
                                <p-sortIcon field="de.nom"></p-sortIcon>
                                <p-columnFilter field="de.nom" matchMode="in" display="menu"
                                [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-multiSelect [ngModel]="value" [options]="filtreEmplacement" placeholder="Any"
                                    
                                        (onChange)="filter($event.value)" optionLabel="name">
                                        <ng-template let-option pTemplate="item">
                                            <div class="multiselect-representative-option">
                                                <span class="ml-1">{{option}}</span>
                                            </div>
                                        </ng-template>
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="a.nom">
                            <div class="flex justify-content-between align-items-center">
                                A
                                <p-sortIcon field="a.nom"></p-sortIcon>
                                <p-columnFilter field="a.nom" matchMode="in" display="menu"
                                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                        <p-multiSelect [ngModel]="value" [options]="filtreEmplacement" placeholder="Any"
                                            (onChange)="filter($event.value)" optionLabel="name">
                                            <ng-template let-option pTemplate="item">
                                                <div class="multiselect-representative-option">
                                                    <span class="ml-1">{{option}}</span>
                                                </div>
                                            </ng-template>
                                        </p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('demandeur')" pSortableColumn="demandeur.prenomNom">
                            <div class="flex justify-content-between align-items-center">
                                Demandeur
                                <p-sortIcon field="demandeur.prenomNom"></p-sortIcon>
                                <p-columnFilter type="text" field="demandeur.prenomNom" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('camion')" pSortableColumn="camion">
                            <div class="flex justify-content-between align-items-center">
                                Camion
                                <p-sortIcon field="camion"></p-sortIcon>
                                <p-columnFilter type="text" field="camion" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('remorque')" pSortableColumn="remorque">
                            <div class="flex justify-content-between align-items-center">
                                Remorque
                                <p-sortIcon field="remorque"></p-sortIcon>
                                <p-columnFilter type="text" field="remorque" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('chauffeur')" pSortableColumn="chauffeur">
                            <div class="flex justify-content-between align-items-center">
                                Chauffeur
                                <p-sortIcon field="chauffeur"></p-sortIcon>
                                <p-columnFilter type="text" field="chauffeur" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th ></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-requisition let-columns="columns">
                    <tr [pContextMenuRow]="requisition">
                        <!-- <td>
							<p-tableCheckbox [value]="Item"></p-tableCheckbox>
                        </td> -->
                   
                        <td>
                            <a *ngIf="estAutorise('requisition_detail')" [routerLink]="'/transport/' + requisition.requisitionId">{{requisition.numero}}</a>
                            <span *ngIf="!estAutorise('requisition_detail')">
                                {{requisition.numero}}
                                </span>
                                <i *ngIf="requisition.type.nom == 'Retour'" class="ml-2 pi pi-arrow-left"
                                style="font-size: 1rem"></i>
                                <i *ngIf="requisition.type.nom == 'Réquisition'" class="ml-2 pi pi-arrow-right"
                                style="font-size: 1rem"></i>
                                <i *ngIf="requisition.type.nom == 'Transfert'" class="ml-2 pi pi-minus"
                                style="font-size: 1rem"></i>
                        </td>
                        <td>{{requisition.date | date:'yyyy-MM-dd'}}</td>
                       <!--  <td><span>
                                <i *ngIf="requisition.type.nom == 'Retour'" class="pi pi-arrow-left"
                                    style="font-size: 1rem"></i>
                                    <i *ngIf="requisition.type.nom == 'Réquisition'" class="pi pi-arrow-right"
                                    style="font-size: 1rem"></i>
                                    <i *ngIf="requisition.type.nom == 'Transfert'" class="pi pi-minus"
                                    style="font-size: 1rem"></i>
                                    {{requisition.type.nom}}
                                </span></td> -->
                                <td><span [class]="'statut ' + requisition.statut.nom.toLowerCase()">
                                    {{requisition.statut.nom}}
                                </span>
                            </td>
                        <td>{{requisition.de.nom}} ({{requisition.de.code}})</td>
                        <td>{{requisition.a.nom}} ({{requisition.a.code}})</td>
                        <td *ngIf="EstColonneSelectionnee('demandeur')">
                            <app-employe-avec-emplacement [employe]="requisition.demandeur"></app-employe-avec-emplacement>
                        </td>
                        <td *ngIf="EstColonneSelectionnee('camion')">
                            {{requisition.camion}}
                        </td>
                        <td *ngIf="EstColonneSelectionnee('remorque')">
                            {{requisition.remorque}}
                        </td>
                        <td *ngIf="EstColonneSelectionnee('chauffeur')">
                            {{requisition.chauffeur}}
                        </td>
                        <td>
                            <div class="flex align-items-center gap-1">
                                <button *ngIf="estAutorise('requisition_detail')" pButton pRipple icon="pi pi-eye"
                                class="p-button-success boutonGrille"
                                (click)="OuvrirDetailRequisition(requisition.requisitionId)"></button>
                             <button *ngIf="estAutorise('requisition_detail')" pButton pRipple icon="pi pi-external-link"
                                class="p-button-secondary boutonGrille"
                                (click)="OuvrirDetailRequisitionNouvelOnglet(requisition.requisitionId)"></button>
                            </div> 
                        </td>
                        
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="6">Aucune réquisition.</td>
                    </tr>
                </ng-template>
            </p-table>
        </p-card>
    </div>


</div>

<p-sidebar [(visible)]="afficherDetailRequisition" [style]="{width:'95%'}" position="left">
	<app-detail-requisition [requisitionId]="detailRequisitionId" *ngIf="afficherDetailRequisition"></app-detail-requisition>
	</p-sidebar>